export default __webpack_public_path__ + "static/media/Angelina.b69f4bd5.jpeg";